/**
 * company.js — Zentrale Anbieter-/Firmendaten (Single Source of Truth).
 *
 * Genutzt von Impressum, Footer und den Rechtstexten. Vor dem Verkaufsstart MÜSSEN
 * die mit "PFLICHT VOR GO-LIVE" markierten Felder mit den echten, ladungsfähigen
 * Daten gefüllt werden (Impressumspflicht §5 DDG / §18 MStV). Solange ein Pflichtfeld
 * leer ist, weist die Impressum-Seite sichtbar darauf hin.
 *
 * Owner-Direktive: in-house gepflegt (kein externer Anwalt) — Eigenrecherche +
 * Disclaimer. Diese Datei ersetzt keine Rechtsberatung.
 */

export const company = {
  // Anbieter / verantwortliche Stelle — übernommen 1:1 aus dem Live-Impressum
  // https://foerderfuchs-bildung.de/impressum/ (abgerufen 2026-07-03):
  // "Nina Schuchardt Förderfuchs, Brentanoweg 12, 45731 Waltrop,
  //  schuchardt@foerderfuchs-bildung.de, www.förderfuchs.de"
  legalName: "Nina Schuchardt — Förderfuchs",
  street: "Brentanoweg 12",
  zip: "45731",
  city: "Waltrop",
  country: "Deutschland",
  // Vertretungsberechtigte Person — bestätigt über foerderfuchs-bildung.de/impressum (2026-07-03)
  representative: "Nina Schuchardt",

  // Kontakt — schuchardt@ ist die einzige über das Live-Impressum verifizierte Adresse.
  // info@/datenschutz@ waren unverifiziert; erst nach Einrichtung der Postfächer umstellen.
  email: "schuchardt@foerderfuchs-bildung.de",
  privacyEmail: "schuchardt@foerderfuchs-bildung.de",
  phone: "",             // Live-Impressum nennt keine Telefonnummer (nur WhatsApp) — nichts erfinden

  // Rechtsform / Register / Steuer (soweit zutreffend)
  // Live-Impressum (2026-07-03) nennt KEINE Rechtsform — Auftritt als natürliche Person
  // ("Nina Schuchardt Förderfuchs"); das erfüllt §5 DDG auch ohne Rechtsform-Label.
  // ACHTUNG Owner-Klärung: Die Website-Navigation nennt zusätzlich "Förderfuchs e.V.
  // (gemeinnütziger Verein)". Läuft DIESE kommerzielle App über den e.V., wären
  // Vereinsregister + Vorstand hier Pflicht — bitte einmal klarstellen.
  legalForm: "",
  registerCourt: "",     // nur bei GmbH/AG/e.V. erforderlich (z. B. "Amtsgericht Recklinghausen")
  registerNumber: "",    // nur bei GmbH/AG/e.V. erforderlich
  vatId: "",             // Live-Impressum nennt keine USt-IdNr. — falls vorhanden: Owner ergänzt (§27a UStG)

  // Inhaltlich verantwortlich i.S.d. §18 Abs. 2 MStV — identisch mit Vertretungsberechtigter
  contentResponsible: "Nina Schuchardt",

  // Web
  website: "https://foerderfuchs-bildung.de",
  productName: "Förderfuchs — KI Social Media Manager",
};

/** Liste der noch fehlenden Pflichtangaben (für sichtbaren Go-Live-Hinweis). */
export function missingImpressumFields() {
  const required = [
    ["street", "Straße + Hausnummer"],
    ["zip", "PLZ"],
    ["city", "Ort"],
    ["representative", "Vertretungsberechtigte Person"],
  ];
  return required.filter(([k]) => !String(company[k] || "").trim()).map(([, label]) => label);
}

/** Mehrzeilige Anschrift als Array (leere Zeilen werden entfernt). */
export function addressLines() {
  const line2 = [company.zip, company.city].filter(Boolean).join(" ");
  return [company.legalName, company.street, line2, company.country].filter(Boolean);
}
